// @flow
import { handleResponseOld, makeGet } from './helpers';

type GetBidLimitBalanceParams = {
    authToken: string,
    bidderId: number,
    catalogId: number,
    deployment: string,
};

export default {
    getBidLimitBalance: ({ authToken, bidderId, catalogId, deployment }: GetBidLimitBalanceParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: `catalog/${catalogId}/bidder/${bidderId}/bidLimit`,
                authToken,
                deployment,
                path: '<APPROVAL-API>',
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
